import { render } from "./Districts.vue?vue&type=template&id=e2421320&scoped=true"
import script from "./Districts.vue?vue&type=script&lang=js"
export * from "./Districts.vue?vue&type=script&lang=js"

import "./Districts.vue?vue&type=style&index=0&id=e2421320&scoped=true&lang=css"

import exportComponent from "D:\\laragon\\www\\subeasy\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2421320"]])

export default __exports__